import { render, staticRenderFns } from "./StyledHierarchicalMenu.vue?vue&type=template&id=2abae570&scoped=true&"
import script from "./StyledHierarchicalMenu.vue?vue&type=script&lang=js&"
export * from "./StyledHierarchicalMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2abae570",
  null
  
)

export default component.exports